/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Upload_Up_To_12_Images_The_FiInputs */

const en_upload_up_to_12_images_the_fi = /** @type {(inputs: Upload_Up_To_12_Images_The_FiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload up to 12 images. The first is your primary. High-quality photos dramatically improve sales.`)
};

const es_upload_up_to_12_images_the_fi = /** @type {(inputs: Upload_Up_To_12_Images_The_FiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sube hasta 12 imágenes. La primera es tu imagen principal. Las fotos de alta calidad mejoran dramáticamente las ventas.`)
};

const fr_upload_up_to_12_images_the_fi = /** @type {(inputs: Upload_Up_To_12_Images_The_FiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Téléchargez jusqu'à 12 images. La première est votre image principale. Des photos de haute qualité améliorent considérablement les ventes.`)
};

const de_upload_up_to_12_images_the_fi = /** @type {(inputs: Upload_Up_To_12_Images_The_FiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lade bis zu 12 Bilder hoch. Das erste ist dein Hauptbild. Hochwertige Fotos verbessern die Verkäufe drastisch.`)
};

const ja_upload_up_to_12_images_the_fi = /** @type {(inputs: Upload_Up_To_12_Images_The_FiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最大12枚の画像をアップロードできます。1枚目がメイン画像になります。高品質な写真は売上を劇的に向上させます。`)
};

const zh_upload_up_to_12_images_the_fi = /** @type {(inputs: Upload_Up_To_12_Images_The_FiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最多上传 12 张图片。第一张将作为主图。高质量的照片将极大提高销量。`)
};

const ar_upload_up_to_12_images_the_fi = /** @type {(inputs: Upload_Up_To_12_Images_The_FiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ارفع حتى 12 صورة. الأولى هي صورتك الرئيسية. الصور عالية الجودة تحسن المبيعات بشكل كبير.`)
};

const id_upload_up_to_12_images_the_fi = /** @type {(inputs: Upload_Up_To_12_Images_The_FiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unggah hingga 12 gambar. Yang pertama akan menjadi gambar utama Anda. Foto berkualitas tinggi secara dramatis meningkatkan penjualan.`)
};

const it_upload_up_to_12_images_the_fi = /** @type {(inputs: Upload_Up_To_12_Images_The_FiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carica fino a 12 immagini. La prima sarà l'immagine principale. Foto di alta qualità aumentano notevolmente le vendite.`)
};

const ru_upload_up_to_12_images_the_fi = /** @type {(inputs: Upload_Up_To_12_Images_The_FiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Загрузите до 12 изображений. Первое — основное. Качественные фото значительно увеличивают продажи.`)
};

const pt_upload_up_to_12_images_the_fi = /** @type {(inputs: Upload_Up_To_12_Images_The_FiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faça upload de até 12 imagens. A primeira é a principal. Fotos de alta qualidade melhoram drasticamente as vendas.`)
};

const ko_upload_up_to_12_images_the_fi = /** @type {(inputs: Upload_Up_To_12_Images_The_FiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`최대 12장의 이미지를 업로드하세요. 첫 번째 이미지가 대표 이미지로 사용됩니다. 고품질 사진은 판매율을 극적으로 높입니다.`)
};

/**
* | output |
* | --- |
* | "Upload up to 12 images. The first is your primary. High-quality photos dramatically improve sales." |
*
* @param {Upload_Up_To_12_Images_The_FiInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const upload_up_to_12_images_the_fi = /** @type {((inputs?: Upload_Up_To_12_Images_The_FiInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Upload_Up_To_12_Images_The_FiInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_upload_up_to_12_images_the_fi(inputs)
	if (locale === "es") return es_upload_up_to_12_images_the_fi(inputs)
	if (locale === "fr") return fr_upload_up_to_12_images_the_fi(inputs)
	if (locale === "de") return de_upload_up_to_12_images_the_fi(inputs)
	if (locale === "ja") return ja_upload_up_to_12_images_the_fi(inputs)
	if (locale === "zh") return zh_upload_up_to_12_images_the_fi(inputs)
	if (locale === "ar") return ar_upload_up_to_12_images_the_fi(inputs)
	if (locale === "id") return id_upload_up_to_12_images_the_fi(inputs)
	if (locale === "it") return it_upload_up_to_12_images_the_fi(inputs)
	if (locale === "ru") return ru_upload_up_to_12_images_the_fi(inputs)
	if (locale === "pt") return pt_upload_up_to_12_images_the_fi(inputs)
	return ko_upload_up_to_12_images_the_fi(inputs)
});